import socket from "@/services/socket";
import {
  useGrimoireStore,
  useSessionStore,
  useDialogStore,
} from "@/stores";
import type {
  Edition,
  Role,
} from "@/types";
export function updateEdition({
  edition,
  roles,
}: {
  edition: Edition;
  roles?: Array<Role>;
}) {
  const session = useSessionStore();
  if (!session.isPlayerOrSpectator) return;
  const grimoireStore = useGrimoireStore();
  grimoireStore.setEdition(edition);
  if (roles) {
    grimoireStore.setCustomRoles(roles);
    if (grimoireStore.roles.size !== roles.length) {
      const missing: string[] = [];
      roles.forEach((r) => {
        const id = r.id;
        if (!grimoireStore.roles.get(id)) missing.push(id);
      });
      useDialogStore().alert(
        `This session contains custom characters that can't be found. ` +
        `Please load them before joining! ` +
        `Missing roles: ${missing.join(", ")}`
      );
      socket.disconnect();
    }
  }
}
